// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1kDtO","list":"BalanceDue_list__1LSj9","listRow":"BalanceDue_listRow__3l4z-","total":"BalanceDue_total__2WKSQ"};